import { Stack } from "@mui/material"
import "./styles.scss"
import { TResourcePreview } from "./types"
import {
    Button,
    EmptyContent,
    FullBar,
    GenericWrapperContext,
    getBrandUrl,
    Icon,
    LoadingContainer,
    Modal
} from "@cakemail-org/ui-components-v2"
import { useContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { updateIframe } from "../../../utils/components"
import { renderToString } from "react-dom/server"
import { useSearchParams } from "react-router-dom"

export function ResourcePreview({ actions, content, className, loading, initFullPreview, thumbnail_url }: TResourcePreview) {
    const genericWrapper = useContext(GenericWrapperContext)
    const { t } = useTranslation()
    const [mobilePreview, setMobilePreview] = useState<boolean>(false)

    const [searchParams, setSearchParams] = useSearchParams()
    const initPreview = initFullPreview || searchParams.get("preview") === "true"

    const [fullPreview, setFullPreview] = useState<boolean>(initPreview)

    const emptyContent = renderToString(
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            boxSizing: 'border-box'
        }}>
            <EmptyContent />
        </div>
    )

    useEffect(() => {
        if (initPreview) {
            setSearchParams()
        }
    }, [])


    useEffect(() => {
        const iframe = document.querySelector(".resourcePreviewIframe") as HTMLIFrameElement
        updateIframe(iframe, content || emptyContent)
    }, [content])

    useEffect(() => {
        setTimeout(() => {
            const iframeFull = document.querySelector(".resourcePreviewIframeFull") as HTMLIFrameElement
            updateIframe(iframeFull, fullPreview ? content || emptyContent : undefined)
        }, 0)
    }, [fullPreview, content])

    function handlePreviewToggle() {
        setMobilePreview(!mobilePreview)
    }

    function handleTogglePreview() {
        setFullPreview(!fullPreview)
    }

    const thumnailHasSmallPreview = !!thumbnail_url

    const previewBtn = <Button color="white" variant='contained' onClick={handleTogglePreview} size="small" iconOnly >
        {t("general-full-preview")}
    </Button>

    let buttons: any[] = [
        <Button className={!mobilePreview ? "active" : ""} color="white" variant='contained' onClick={handlePreviewToggle} size="small" iconOnly >
            <Icon name="Desktop18" />
        </Button>,
        <Button className={mobilePreview ? "active" : ""} color="white" variant='contained' onClick={handlePreviewToggle} size="small" iconOnly >
            <Icon name="Mobile18" />
        </Button>,
        previewBtn
    ]

    if (thumnailHasSmallPreview) {
        buttons = [previewBtn]
    }


    return <Stack className={"resourcePreviewContainer " + className}>
        <FullBar
            className="resourcePreviewHeader"
            left={buttons}
            right={actions}
        />
        <Stack className={`resourcePreviewContent ${loading ? "loading" : ""}`}>
            {thumbnail_url && <img src={thumbnail_url} alt="thumbnail" />}
            {!thumbnail_url && <LoadingContainer loading={content === undefined}>
                <iframe className={`resourcePreviewIframe ${mobilePreview ? "mobile" : "desktop"}`} />
            </LoadingContainer>
            }
            <LoadingContainer loading={loading} className="loadingOverlay" />
        </Stack>

        <Modal
            open={fullPreview}
            className="resourcePreviewFullPreview"
            heading={{
                logoUrl: getBrandUrl({ brand: genericWrapper.partnerBrand, elKey: "logo" }),
                closeBtnText: t("general-close"),
                closeBtnOnClick: handleTogglePreview,
                actions: [
                    <Button className={!mobilePreview ? "active" : ""} color="shade100" variant='contained' onClick={handlePreviewToggle} iconOnly >
                        <Icon name="Desktop18" />
                    </Button>,
                    <Button className={mobilePreview ? "active" : ""} color="shade100" variant='contained' onClick={handlePreviewToggle} iconOnly >
                        <Icon name="Mobile18" />
                    </Button>
                ]
            }}
            content={<>
                <iframe className={`resourcePreviewIframeFull ${mobilePreview ? "mobile" : "desktop"}`} />
                <LoadingContainer loading={content === undefined}></LoadingContainer>
            </>
            }
        />
    </Stack>
}